import * as React from "react";
import { Card, CardHeader, CardContent } from "@mui/material";
import {
  Bar,
  ComposedChart,
  Legend,
  Line,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";
import capitalize from "lodash/capitalize";

import { ChartData } from "../types";

const barColors: Record<string, string> = {
  guardian: "#76B8D8",
  lincoln: "#3D628B",
  principal: "#7C3D8C",
};

export type MonthlyProgressChartCardProps = {
  title?: string;
  data: ChartData[];
};

export const MonthlyProgressChartCard: React.FC<
  MonthlyProgressChartCardProps
> = ({ title = "Monthly Progress", data }) => {
  const barMetricKeys =
    Array.isArray(data) && data.length > 0
      ? Object.keys(data[0]).filter(
          (d) => d !== "name" && d !== "goal" && d !== "payout2024",
        )
      : [];

  const formatCurrency = (v: number): string =>
    `$${v.toLocaleString("en-US", { maximumFractionDigits: 0 })}`;

  return (
    <Card
      elevation={2}
      sx={{
        borderRadius: 3,
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <CardHeader
        title={title}
        sx={{
          "& .MuiCardHeader-title": {
            fontSize: 18,
            fontWeight: 500,
          },
          pb: 0,
        }}
      />
      <CardContent sx={{ flex: 1, pt: 1 }}>
        <ResponsiveContainer width="100%" aspect={2}>
          <ComposedChart
            responsive
            data={data}
            margin={{ left: 60, right: 60 }}
            style={{ paddingBottom: 25 }}
          >
            <XAxis
              dataKey="name"
              width="auto"
              angle={45}
              textAnchor="end"
              tickMargin={15}
            />
            <YAxis
              domain={[0, "auto"]}
              tickFormatter={(value) => formatCurrency(value)}
            />
            <Legend verticalAlign="bottom" />

            <Line type="monotone" dataKey="goal" stroke="#7AC26B" name="Goal" />
            <Line
              type="monotone"
              dataKey="payout2024"
              stroke="#C54C4C"
              name="2024 Payout"
            />

            {barMetricKeys.map((key) => (
              <Bar
                key={key}
                stackId="a"
                background
                dataKey={key}
                name={capitalize(key)}
                fill={barColors[key]}
              />
            ))}
          </ComposedChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};
